import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@ui/dialog";
import TranslatedText from "@components/items/display/TranslatedText";
import { ShadcnButton } from "@components/items/display/ShadcnButton";

const SuccessReplacmentDialog = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="flex w-[500px] flex-col items-center justify-center gap-12 bg-white py-8 sm:rounded-[20px] dark:border-none dark:bg-[#010D19]">
        <DialogHeader className="flex flex-col items-center justify-center gap-2">
          <DialogTitle className="flex items-center justify-center gap-3 text-[40px] font-bold text-primary">
            <TranslatedText
              text={`full-books.success-replacment`}
              className="dark:text-[#64A6E1]"
            />
            <img
              src="/assets/images/congratulations.png"
              alt="premium"
              className="h-[40px] w-[40px]"
            />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription></DialogDescription>
        <div className="flex w-[80%] flex-col items-center justify-center gap-12 text-center">
          <TranslatedText
            text={`full-books.book-avaliable`}
            className="text-[20px] leading-8 dark:text-[#91949C]"
          />
          <ShadcnButton
            className="flex w-full items-center justify-center gap-1 bg-primary px-6 py-7 text-[20px] font-medium text-white hover:bg-primary hover:opacity-85 dark:bg-[#64A6E1] dark:text-[#010D19] dark:hover:bg-[#64A6E1]"
            onClick={() => setOpen(false)}
          >
            <TranslatedText text="full-books.continue" />
          </ShadcnButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessReplacmentDialog;
